import { Row, Col, Card, Pagination } from "react-bootstrap";
import { images } from "../../../../constants";
import { useNavigate, useLocation } from "react-router-dom";
import RedoIcon from "@mui/icons-material/Redo";
import { useEffect, useState, useRef } from "react";
import GradeIcon from "@mui/icons-material/Grade";
import ShareModel from "../../../Sharemodel";
import ShareOption from "../../../Shareoption";
import { useDispatch, useSelector } from "react-redux";
import { updateItemName } from "../../../../store/modules/itemdata";
import { useGetAllConnectedQuery } from "../../../../features/connection/connectionApiSlice";
import { getAsset } from "../../../../helpers/helper";
import { getImageWithFallback } from "../../../../helpers/imageHelper";
import dummyezi from "../../../../assets/images/dummy/dummyezi.png";
import noImagePlaceholder from "../../../../assets/images/dummy/no_image_placeholder.png";
import ShopCardSkeleton from "../../../common/SkeletonLoader/ShopCardSkeleton";
import ConnectProfileModal from "../../../Connect_Modal_Buy";
import { encodeId } from "../../../../utils/idObfuscator";
import { generateShopSlug } from "../../../../utils/slugUtils";
import { FailedNotify } from "../../../../constants/tostify";
const Shops = ({
  link,
  title,
  handleShow,
  Getdata,
  shopdata,
  Newitemdataraw,
  isloading,
  itemmdata,
  alldata,
  isServerPaginated = false,
  allowedConnectBusinessTypes,
}) => {
  const dispatch = useDispatch();
  const { name } = useSelector((state) => state.user);

  // Fetch logged-in user's connections
  const { data: connectedDataResponse } = useGetAllConnectedQuery(
    { userid: name?._id },
    { skip: !name?._id, refetchOnMountOrArgChange: true },
  );
  // A request only shows up in `requested` until the other side accepts it,
  // so we use it purely to label the button "Requested" while pending.
  const requestedList = connectedDataResponse?.requested || [];

  const matchesShop = (list, shopId) =>
    list.some(
      (c) =>
        c.senderid === shopId ||
        c.recieverid === shopId ||
        c.sendershopid === shopId ||
        c.recievershopid === shopId,
    );

  const isShopRequested = (shopId) => matchesShop(requestedList, shopId);

  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const [shareShopId, setShareShopId] = useState(null);
  const [connectbuyModal, setConnectbuyModal] = useState(false);
  const [connectShopData, setConnectShopData] = useState(null);
  const [dummyBoxes, setDummyBoxes] = useState(100); // Start with 100 dummy boxes
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const itemsPerPage = 50; // Limit to 50 items (shops + dummy) per page
  const navigate = useNavigate();
  const location = useLocation();

  // Calculate total items (shops + dummy boxes) and pages
  const totalItems = Math.max(shopdata?.length || 0, 100); // At least 100 items (shops or dummy)
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate the items to display for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentShops = isServerPaginated
    ? shopdata
    : shopdata?.slice(indexOfFirstItem, indexOfLastItem);
  const currentDummyCount = isServerPaginated
    ? 0
    : Math.max(0, 100 - (currentShops?.length || 0));

  useEffect(() => {
    if (location.pathname === "/business-dashboard") {
      Newitemdataraw();
    }
  }, []);

  useEffect(() => {
    // Adjust number of dummy boxes based on currentShops length
    setDummyBoxes(Math.max(0, 100 - (shopdata?.length || 0))); // Total dummy boxes
  }, [shopdata]);

  const closemodal = () => setShowmodal(false);
  const myStateRef = useRef(0);
  const setMyState = (newValue) => {
    myStateRef.current = newValue;
  };
  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => {
    setShowmodal(false);
    setShowshare(true);
  };
  const Navigatefun = async (e, shopName, shop) => {
    // Individually-posted property ads (no companyid, just a userid) don't
    // have a company profile to open — they ARE the item. Send those
    // straight to the single-ad view instead of the company profile route.
    if (shop?.isPersonalListing) {
      navigate(`/single-property-addview/${e}`);
      return;
    }

    const databyshopid = await itemmdata?.filter((item) =>
      location.pathname === "/find-property"
        ? item?.companyid === e
        : location.pathname === "/find-job"
          ? item?.companyId === e
          : item?.shopid === e,
    );

    dispatch(updateItemName(databyshopid));

    const slug = generateShopSlug(shopName, e);

    if (
      link === "/retailer-userprofile" ||
      link === "/wholeseller-userprofile" ||
      link === "/services-online"
    ) {
      navigate(`${link}/${encodeId(e)}`);
    } else {
      navigate(`${link}/${slug}`);
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  // Combine shops, ads, and dummy boxes, inserting ads after every 10 cards
  const renderItems = () => {
    const items = [];
    const adCards = [
      { src: images.Shopadone, key: "ad-1" },
      { src: images.Shopadtwo, key: "ad-2" },
      { src: images.Shopadthree, key: "ad-3" },
    ];

    // Combine shops and dummy boxes for the current page
    const allItems = [];

    // Add shop cards
    currentShops?.forEach((shop) => {
      allItems.push({ type: "shop", data: shop });
    });

    // Add dummy boxes for the current page
    if (location.pathname !== "/business-dashboard") {
      Array.from({ length: currentDummyCount }).forEach((_, index) => {
        allItems.push({ type: "dummy", data: index + indexOfFirstItem });
      });
    }

    // Slice items to ensure no more than itemsPerPage
    const paginatedItems = allItems.slice(0, itemsPerPage);

    // Render items with ads after every 10 cards
    paginatedItems.forEach((item, index) => {
      if (item.type === "shop") {
        const shop = item.data;
        items.push(
          <Col
            lg="4"
            xl="3"
            md="4"
            sm="6"
            xs="6"
            className="mt-1 position-relative"
            key={shop?._id}
          >
            <Card
              className={
                location.pathname === "/business-dashboard"
                  ? "ShopsCards_2 mt-3"
                  : "ShopsCards mt-3"
              }
            >
              <div className="fix-img">
                <img
                  className="c_img"
                  src={
                    location.pathname === "/find-services"
                      ? getImageWithFallback(shop?.images).isDummy
                        ? noImagePlaceholder
                        : getAsset(shop?.images)
                      : getImageWithFallback(shop?.image).isDummy
                        ? noImagePlaceholder
                        : getAsset(shop?.image)
                  }
                  alt="Shop Cover"
                  crossOrigin="anonymous"
                  onError={(e) => {
                    e.target.onerror = null; // prevents looping
                    e.target.src = noImagePlaceholder;
                  }}
                />
              </div>
              <Card.Body className="p-2">
                <button
                  className="text-white bg-blue share_font btn-position-absolute"
                  onClick={() => {
                    handleShow && handleShow();
                    setShareShopId(shop?._id);
                    setShowmodal(true);
                  }}
                >
                  Share <RedoIcon className="share_icon_f" />
                </button>
                <Card.Title className="font-sm-15 mb-0 pb-1">
                  <div className="d-flex justify-content-between">
                    <div>
                      {(
                        shop?.shopname ||
                        shop?.companyname ||
                        shop?.profileName ||
                        shop?.name ||
                        "Shop"
                      ).slice(0, 7)}
                      ..
                    </div>
                    <div className="font_12">(Views:{shop?.views || 0})</div>
                  </div>
                </Card.Title>
                <Card.Text as="div" className="font-sm font-primary mb-2">
                  <div className="d-flex justify-content-between">
                    <div>
                      {(
                        shop?.shopaddress ||
                        shop?.companyaddress ||
                        shop?.address ||
                        "No Address"
                      ).slice(0, 16)}
                      ..
                    </div>
                    <div style={{ color: "black" }}>
                      <b>
                        {Number(shop?.ratings || 0).toFixed(1)} &nbsp;
                        <GradeIcon
                          style={{
                            fontSize: "medium",
                            color: "#FFE507",
                          }}
                        />
                      </b>
                    </div>
                  </div>
                </Card.Text>
                <div className="d-flex justify-content-between">
                  <button
                    className="viewshop w-50 pe-1 ps-2 text-white bg-blue"
                    onClick={() =>
                      Navigatefun(
                        shop?._id,
                        shop?.shopname ||
                          shop?.companyname ||
                          shop?.profileName ||
                          "shop",
                        shop,
                      )
                    }
                  >
                    View
                  </button>
                  <button
                    style={{
                      color: isShopRequested(shop?._id) ? "#856404" : "#0353A4",
                      backgroundColor: isShopRequested(shop?._id)
                        ? "#fff3cd"
                        : "white",
                      border: isShopRequested(shop?._id)
                        ? "1px solid #ffc107"
                        : "1px solid #0353A4",
                    }}
                    className="viewshop ps-3 pe-3 ms-1 fw-bold"
                    onClick={() => {
                      const ownerId = shop?.userid?._id || shop?.userid;
                      if (
                        name?._id &&
                        ownerId &&
                        String(ownerId) === String(name._id)
                      ) {
                        FailedNotify("You cannot connect to your own shop");
                        return;
                      }
                      setConnectShopData(shop);
                      setConnectbuyModal(true);
                    }}
                  >
                    {isShopRequested(shop?._id) ? "Requested" : "Connect"}
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>,
        );
      } else if (item.type === "dummy") {
        items.push(
          <Col
            lg="4"
            xl="3"
            md="4"
            sm="6"
            xs="6"
            className="mt-1 position-relative"
            key={`dummy-${item.data}`}
          >
            <Card
              className="ShopsCards mt-3"
              style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
            >
              <div className="fix-img">
                <img
                  className="c_img"
                  src={dummyezi}
                  alt="Selectezi Logo"
                />
              </div>
              <Card.Body
                className="p-2 d-flex align-items-center justify-content-center"
                style={{ minHeight: "84px" }}
              >
                <Card.Text
                  as="div"
                  className="font-sm font-primary mb-0 text-center"
                >
                  <b>Explore with Selectezi</b>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>,
        );
      }

      // Add ads after every 10 cards (shops or dummy)
      if ((index + 1) % 10 === 0 && index < paginatedItems.length - 1) {
        adCards.forEach((ad) => {
          items.push(
            <Col
              lg="4"
              xl="3"
              md="4"
              sm="6"
              xs="6"
              className="mt-1"
              key={`${ad.key}-${index}`}
            >
              <Card
                className="ShopsCards mt-3 p-4"
                style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
              >
                <Card.Img
                  src={ad.src}
                  alt="Advertisement"
                  style={{ objectFit: "cover", height: "132px", width: "100%" }}
                  className="mt-3"
                />
                <Card.Body className="p-2"></Card.Body>
              </Card>
            </Col>,
          );
        });
      }
    });

    return items;
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal}
        shopid={shareShopId}
        handleClosemodal={closemodal}
        handleShowshare={handleShowshare}
      />
      {connectShopData && (
        <ConnectProfileModal
          connectbuyModal={connectbuyModal}
          setConnectbuyModal={setConnectbuyModal}
          shopData={connectShopData}
          allowedConnectBusinessTypes={allowedConnectBusinessTypes}
        />
      )}
      <div className="me-lg-2 ms-lg-2 me-md-2 ms-md-2 me-sm-2 ms-sm-2 me-2 ms-2">
        <div className="shops-container">
          {/* <div
            className="d-flex justify-content-between align-items-center rounded p-3"
            style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
          >
            <button
              style={{
                backgroundColor: "#0b4ecb",
                color: "#ffffff",
                border: "none",
                padding: "3px 8px",
                borderRadius: "5px",
                fontSize: "11px",
                fontWeight: "400",
              }}
              onClick={() => navigate("/invest-form")}
            >
              Invest with selectezi
            </button>
            <button
              style={{
                backgroundColor: "#0b4ecb",
                color: "#ffffff",
                border: "none",
                padding: "3px 8px",
                borderRadius: "5px",
                fontSize: "11px",
                fontWeight: "400",
              }}
              onClick={() => navigate("/explor-opportunities")}
            >
              Invest in other opportunities
            </button>
            <button
              style={{
                backgroundColor: "#0b4ecb",
                color: "#ffffff",
                border: "none",
                padding: "3px 8px",
                borderRadius: "5px",
                fontSize: "11px",
                fontWeight: "400",
              }}
              onClick={() => navigate("/wallet-profile")}
            >
              Investment Profile
            </button>
            <button
              style={{
                backgroundColor: "#0b4ecb",
                color: "#ffffff",
                border: "none",
                padding: "3px 8px",
                borderRadius: "5px",
                fontSize: "11px",
                fontWeight: "400",
              }}
              onClick={() => navigate("/chatbot")}
            >
              Find Solution and Consultancy
            </button>
          </div> */}
          <Row className="shops_buying_h noscroll">
            {isloading
              ? Array.from({ length: 15 }).map((_, index) => (
                  <ShopCardSkeleton key={index} />
                ))
              : (() => {
                  const items = renderItems();
                  return items.length > 0 ? (
                    items
                  ) : (
                    <div className="w-100 text-center mt-5 mb-5">
                      <h4 className="text-muted fw-bold">No Data found</h4>
                    </div>
                  );
                })()}
          </Row>
          {totalPages > 1 && !isServerPaginated && (
            <div className="d-flex justify-content-center mt-4">
              <Pagination>
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Shops;
